export const STATUS_CADERNOCONFORMIDADE = {
    SolicitacaoCriacaoEmAnalise: 1,
    CorrecaoCriacaoSolicitada: 2,
    SolicitacaoCriacaoAprovada: 3,
    EmPreenchimento: 4,
    EmAnalisePeloRegulatorio: 5,
    CorrecaoSolicitada: 6,
    EmCorrecao: 7,
    AprovadopeloRegulatorio: 8,
    Concluido: 9,
    Cancelado: 10
}

export const isCriacaoEmAnaliseRegulatorio = (status: number) =>
    status === STATUS_CADERNOCONFORMIDADE.SolicitacaoCriacaoEmAnalise
    || status === STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada;

export const isFinalizacaoEmAnaliseRegulatorio = (status: number) =>
    status === STATUS_CADERNOCONFORMIDADE.EmAnalisePeloRegulatorio
    || status === STATUS_CADERNOCONFORMIDADE.CorrecaoSolicitada
    || status === STATUS_CADERNOCONFORMIDADE.EmCorrecao;

export const podeRequisitanteSolicitarCriacaoCaderno = (
    status: number | undefined,
    temCadernoExistente: boolean,
) =>
    status === STATUS_CADERNOCONFORMIDADE.CorrecaoCriacaoSolicitada
    || (!temCadernoExistente && (status === undefined || status === 0));